import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  LogoLinkTitle: {
    id: 'header_logo_link_title',
    defaultMessage: 'Back to home page',
  },
  LogoTitle: {
    id: 'header_logo_title',
    defaultMessage:
      'University of Applied Sciences and Arts Northwestern Switzerland',
  },
  LogoAlt: {
    id: 'header_logo_alt',
    defaultMessage:
      'Logo of the University of Applied Sciences and Arts Northwestern Switzerland',
  },
  Schools: {
    id: 'header_schools',
    defaultMessage: 'Schools',
  },
  TenSchools: {
    id: 'header_ten_schools',
    defaultMessage: 'Ten Schools',
  },
  OneGoal: {
    id: 'header_one_goal',
    defaultMessage: 'One Goal',
  },
  SchoolsIntro: {
    id: 'header_schools_intro',
    defaultMessage:
      'The FHNW comprises 10 schools with different specializations. Select a school to see its specific courses, study programmes and information.',
  },
  ToggleDarkMode: {
    id: 'header_toggle_dark_mode',
    defaultMessage: 'Toggle dark mode',
  },
  OpenNavigation: {
    id: 'header_open_navigation',
    defaultMessage: 'Open navigation',
  },
  StartSearch: {
    id: 'header_start_search',
    defaultMessage: 'Start search',
  },
  Close: {
    id: 'Close',
    defaultMessage: 'Close',
  },
});
